<template>
  <nav class="bg-blue_primary">
    <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">
        <!-- Mobile menu button-->
        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
          <button
            @click="toggleMobileMenu"
            type="button"
            class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            aria-controls="mobile-menu"
            :aria-expanded="isMobileMenuOpen.toString()"
          >
            <span class="sr-only">Open main menu</span>
            <svg
              v-if="!isMobileMenuOpen"
              class="block h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
            <svg
              v-else
              class="block h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start"
        >
         
          <img src="https://upload.wikimedia.org/wikipedia/commons/2/2b/Ziply_Fiber_logo.svg" alt="Logo" class="h-9 w-auto mr-4" />

          <div class="hidden sm:ml-6 sm:block">
            <div class="flex space-x-4">
             
              <a
                href="#"
                :class="{
                  'bg-gray-900 text-white': selectedButton === 'dashboard',
                  'text-gray-300 hover:bg-gray-700 hover:text-white':
                    selectedButton !== 'dashboard',
                }"
                @click="goDashboard"
                class="rounded-md px-3 py-2 text-sm font-medium"
              >
                Dashboard
              </a>
             
              <a
                href="#"
                :class="{
                  'bg-gray-900 text-white': selectedButton === 'residential',
                  'text-gray-300 hover:bg-gray-700 hover:text-white':
                    selectedButton !== 'residential',
                }"
                @click="updateType('residential')"
                class="rounded-md px-3 py-2 text-sm font-medium"
                aria-current="page"
              >
                Residential
              </a>
             
              <a
                href="#"
                :class="{
                  'bg-gray-900 text-white': selectedButton === 'commercial',
                  'text-gray-300 hover:bg-gray-700 hover:text-white':
                    selectedButton !== 'commercial',
                }"
                @click="updateType('commercial')"
                class="rounded-md px-3 py-2 text-sm font-medium"
              >
                Commercial
              </a>
            </div>
          </div>
        </div>

        <div
          class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
        >
         
          <div class="relative ml-3">
            <button
              @click="toggleProfileMenu"
              type="button"
              class="relative flex items-center justify-center h-8 w-8 rounded-full bg-gray-200 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-200"
              aria-expanded="false"
              aria-haspopup="true"
            >
              <span class="sr-only">Open user menu</span>
              <div
                class="flex items-center justify-center h-8 w-8 bg-gray-800 rounded-full"
              >
                {{ initials }}
              </div>
            </button>

            <div
              v-if="isProfileMenuOpen"
              class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
            >
              <a
                href="#"
                class="block px-4 py-2 text-sm text-gray-700"
                @click="logout"
              >
                Sign out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile menu -->
    <div v-if="isMobileMenuOpen" class="sm:hidden" id="mobile-menu">
      <div class="space-y-1 px-2 pb-3 pt-2">
   
        <a
          href="#"
          :class="{
            'bg-gray-900 text-white': selectedButton === 'dashboard',
            'text-gray-300 hover:bg-gray-700 hover:text-white':
              selectedButton !== 'dashboard',
          }"
          @click="goDashboard"
          class="block rounded-md px-3 py-2 text-base font-medium"
        >
          Dashboard
        </a>
       
        <a
          href="#"
          :class="{
            'bg-gray-900 text-white': selectedButton === 'residential',
            'text-gray-300 hover:bg-gray-700 hover:text-white':
              selectedButton !== 'residential',
          }"
          @click="updateType('residential')"
          class="block rounded-md px-3 py-2 text-base font-medium"
          aria-current="page"
        >
          Residential
        </a>
      
        <a
          href="#"
          :class="{
            'bg-gray-900 text-white': selectedButton === 'commercial',
            'text-gray-300 hover:bg-gray-700 hover:text-white':
              selectedButton !== 'commercial',
          }"
          @click="updateType('commercial')"
          class="block rounded-md px-3 py-2 text-base font-medium"
        >
          Commercial
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const isMobileMenuOpen = ref(false);
    const isProfileMenuOpen = ref(false);
    const router = useRouter();
    const store = useStore();
    const pagination = computed(() => store.getters.pagination);
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    const initials = userData
      ? `${userData.name[0]}${userData.last_name[0]}`.toUpperCase()
      : "";

    const selectedButton = ref(
      sessionStorage.getItem("selectedButton") || "residential"
    );

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
    };

    const toggleProfileMenu = () => {
      isProfileMenuOpen.value = !isProfileMenuOpen.value;
    };

    const logout = () => {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("selectedButton");
      router.push({ name: "Login" });
    };

    const updateType = async (newType) => {
      selectedButton.value = newType; 
      sessionStorage.setItem("selectedButton", newType);
      await store.commit("setLoading", true);
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      await store.commit("setPagination", {
        filters: {
          limit: 15,
          page: 1,
          submitter_email_contact: userData.email,
        },
      });
      await store.dispatch("fetchData", pagination.value.filters);
      window.dispatchEvent(new Event("storage"));
      router.push({name: "HomeTable"});
      await store.commit("setLoading", false);
    };

    const goDashboard = async () => {
      selectedButton.value = "dashboard";
      sessionStorage.setItem("selectedButton", "dashboard");
      router.push({name: "Dashboard"});
    }

    return {
      isMobileMenuOpen,
      isProfileMenuOpen,
      toggleMobileMenu,
      toggleProfileMenu,
      logout,
      initials,
      selectedButton,
      updateType,
      goDashboard
    };
  },
};
</script>
